import { StyledPartnerCard } from '../../Organisms/PartnerCard/styles'
import { StyledServiceCard } from '../../Organisms/ServiceCard/styles'
import { styled } from '../../Styles/stitches.config'

export const StyledContentLoader = styled('div', {
    pointerEvents: 'none',

    [`& ${StyledPartnerCard}, & ${StyledServiceCard}`]: {
        bgc: '$white',
        border: '1px solid $neutral300',

        '@desktop': {
            p: '$3',
        },

        '@mobile': {
            p: '$2',
        },
    },
})
